export const EXCLUDE_CHECKBOX_TOOLTIP = {
    disabledText: "Фильтр по всем значениям в справочнике, кроме выбранных",
    activeText: "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
    notActiveText: "Включить фильтр по всем значениям в справочнике, кроме выбранных",
};
